import { render, staticRenderFns } from "./nemi-footer.vue?vue&type=template&id=33bd2918&scoped=true&"
import script from "./nemi-footer.vue?vue&type=script&lang=ts&"
export * from "./nemi-footer.vue?vue&type=script&lang=ts&"
import style0 from "./nemi-footer.vue?vue&type=style&index=0&id=33bd2918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd2918",
  null
  
)

export default component.exports